import i18n from "@/i18n";

const testVariants = [
  { id: "true", name: i18n.t("integrations.ofr.test.test_only") },
  { id: "false", name: i18n.t("integrations.ofr.test.no_test") }
];

export { testVariants };
